import React from 'react'
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
export default function DeliverWay() {
  return (
    <>
    <Box component={'container'}>
    <Box sx={{
        display: 'flex',
        flexDirection: {lg: 'row', md: 'row', sm: 'column', xs: 'column'},
        justifyContent:'center'
      }}>


          


          {/* <Box > */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: {sm: "center"},
                textAlign: {sm: "center"},
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  // width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "600",
                    // fontSize: "40px",
                    fontSize: {lg: "40px", md: "40px", sm: "30px", xs: "25px"},
                    lineHeight: "56px",
                    // textAlign: "center",
                    textAlign: {xs: "center"},
                  }}
                >
                  Deliver your way in app
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "400",
                    fontSize: {lg: "18px", md: "18px", sm: "16px", xs: "14px"},
                    lineHeight: "26.1px",
                    width: "100%",
                    width: {lg: "416px", md: "100%", sm: "100%", xs: "95%"},
                    justifyContent: "center",
                    textAlign: {lg: "left" , md: "left", sm: "left", xs: "center"},
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row",width:'100%', justifyContent: {lg: "start" , md: "start", sm: "start", xs: "center"},}}>
              <Button
                    sx={{
                      color: "#9EA3AE",
                      textTransform: "capitalize",
                      fontSize: "18px",
                      fontWeight: "400",
                    }}
                  >
                    <img
                    src="./images/AppStore.svg"
                    alt=""
                    width={"158px"}
                    height={"55.96px"}
                  />
                  </Button>

                  <Button
                    sx={{
                      color: "#9EA3AE",
                      textTransform: "capitalize",
                      fontSize: "18px",
                      fontWeight: "400",
                    }}
                  >
                    <img
                    src="./images/GooglePlay.svg"
                    alt=""
                    width={"158px"}
                    height={"55.96px"}
                  />
                  </Button>
                  </Box>
              {/* <Box
                
              >
                <img src="./images/playstoreLogo.svg" alt="" width={"100%"}/>
              </Box> */}
            </Box>

            <Box >
            <Box sx={{width: "100%"}}>
              <img
                src="./images/phones.svg"
                alt=""
                width="100%"
                height="auto"
              />
            </Box>
          </Box>
          {/* </Box> */}



        </Box>




    </Box>
    </>
  )
}
